import React from 'react';
import { Star } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Podcast Host',
      company: 'Tech Talk Weekly',
      text: 'LTV Production transformed our podcast into a premium visual experience. The team\'s attention to detail and professional setup made filming effortless.',
      rating: 5
    },
    {
      id: 2,
      name: 'Marcus Reid',
      role: 'Brand Director',
      company: 'Stellar Brands',
      text: 'Working with LTV on our brand documentary was exceptional. They captured our story with cinematic quality and delivered beyond our expectations.',
      rating: 5
    },
    {
      id: 3,
      name: 'Elena Martinez',
      role: 'Event Organizer',
      company: 'Caribbean Festival Group',
      text: 'LTV Carnival covered our event with incredible energy and professionalism. The footage was stunning and captured the true spirit of our celebration.',
      rating: 5
    }
  ];

  return (
    <section className="relative z-10 py-24 sm:py-32 border-t border-white/[0.06] bg-white/[0.015]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="mb-14 sm:mb-20">
          <p className="ltv-eyebrow text-red-500 mb-4">06 — Testimonials</p>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.05]">
            Trusted by creators
            <br />
            <span className="text-gray-500">and brands worldwide.</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="rounded-2xl border border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.06] hover:border-red-500/30 p-7 sm:p-8 transition-all duration-300 flex flex-col">
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-red-500 text-red-500" />
                ))}
              </div>
              <p className="text-gray-300 mb-8 leading-relaxed text-sm sm:text-base flex-1">"{testimonial.text}"</p>
              <div className="border-t border-white/[0.08] pt-5">
                <p className="font-display font-bold text-white">{testimonial.name}</p>
                <p className="text-gray-400 text-sm">{testimonial.role}</p>
                <p className="text-gray-600 text-sm">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
